import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const Edit = (props: any) => {
  return <ExpandMoreIcon {...props} />;
};

export default Edit;
